// Only list pages whose English and Spanish versions have equivalent, reviewed
// main content. The i18n theme creates /es/ routes even when their body is
// still English, so route existence alone is not evidence of translation.
// Update this allowlist only after the Spanish main content is published.
const localizedPages = new Set([
  "/",
  "/accounting-automation-engineering",
  "/accounting-software-development",
  "/ai-engineers",
  "/blog",
  "/careers",
  "/careers-android",
  "/careers-marketing",
  "/careers-video-editor",
  "/case-studies",
  "/contact-center",
  "/cpaas-engineering",
  "/dedicated-engineering-squads",
  "/devops-sre",
  "/fintech-engineering",
  "/nearshore-software-development",
  "/trabaja-con-nosotros",
]);

// Five .es.md files still contain English main copy; they intentionally do
// not appear here. Keep this list in sync with the SEO-10 language audit.
const translatedArticles = new Set([
  "/aws-s3-secure-direct-upload",
  "/continuous-integration-s3-cloudfront",
  "/error-handling-nodejs",
  "/federal-authentication-node",
  "/frontend-frameworks",
  "/how-to-deploy-react-to-s3-cloudfront",
  "/ideal-nodejs-project-structure",
  "/ionic-circleci2",
  "/job-queues-cqrs-nodejs-mongodb-agenda",
  "/nodejs-crash-exception-handler",
  "/nodejs-frameworks",
  "/nodejs-jwt-authentication-oauth",
  "/nodejs-scalability-issues",
  "/pagination-in-nodejs-mongo",
  "/react-hooks",
  "/reversing-tinder-api-with-nodejs",
  "/s3-cloudfront-angular-react",
  "/theory-building-software",
]);

const normalizePath = (pathname) => {
  const path = pathname.replace(/\/+$/, "");
  return path || "/";
};

const getArticleContentLocale = (frontmatter) => {
  if (frontmatter.locale === "es" && !translatedArticles.has(`/${frontmatter.slug}`)) {
    return "en";
  }
  return frontmatter.locale || "en";
};

const getArticleCanonicalUrl = (frontmatter, siteUrl) => {
  const origin = siteUrl.replace(/\/+$/, "");
  const locale = getArticleContentLocale(frontmatter);
  const prefix = locale === "en" ? "" : `/${locale}`;
  return `${origin}${prefix}/${frontmatter.slug}`;
};

const getLocalizedAlternates = (pathname, siteUrl) => {
  const path = normalizePath(pathname);
  const englishPath = path === "/es" ? "/" : path.replace(/^\/es\//, "/");
  if (!localizedPages.has(englishPath) && !translatedArticles.has(englishPath)) {
    return null;
  }

  const origin = siteUrl.replace(/\/+$/, "");
  return {
    en: `${origin}${englishPath === "/" ? "" : englishPath}`,
    es: `${origin}/es${englishPath === "/" ? "" : englishPath}`,
  };
};

module.exports = { getArticleContentLocale, getArticleCanonicalUrl, getLocalizedAlternates };
